/* --------------------------------------------------------------------------------------
   xwKeyboard.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import { data } from 'autoprefixer'

/* eslint semi: ["error", "never"]*/
export class xwKeyboard {
    /* @ngInject*/
    constructor(appSettings) {
        this.restrict = 'A'
        this.scope = {
            onVisible: '&',
            onChange: '&',
            onAccepted: '&',
            autoAccept: '<',
            onCancel: '&',
            beforeClose: '&',
            beforeVisible: '&',
            onHide: '&',
            ngModel: '=',
            backgroundSlide: '<'
        }
        this.appSettings = appSettings
    }
    link(scope, elem, attrs) {
        let options = {
            layout: attrs.layout || navigator.language.substr(0,2).toLowerCase(),
            theme: attrs.theme || this.appSettings.primaryColor,
            restrictInput: attrs.restrictInput,
            preventPaste: attrs.preventPaste,
            initialPlaceholder: attrs.initialPlaceholder,
            maxlength: attrs.maxLength,
            autoAccept: scope.autoAccept,
            backgroundSlide: scope.backgroundSlide,
            visible: () => this.visible(scope, attrs.layout),
            change: () => this.change(scope, elem),
            canceled: () => scope.onCancel(),
            beforeClose: () => scope.beforeClose(),
            beforeVisible: () => scope.beforeVisible(),
            accepted: (ev, kbd, e) => scope.onAccepted(),
            hidden: () => scope.onHide(),
            stayOpen: false
        }
    
        elem.first().xrxkeyboard(options)

        scope.$on('$destroy', () => {
            elem.first().xrxkeyboard('destroy').remove()
        })

        elem.bind('keydown keypress', (ev) => {
            if (ev.which === 13) {
                elem.first().getkeyboard().accept()
            }
        })
    }
    visible(scope, layout) {
        if (layout && layout.includes('xrxNum')) {
            let buttonContent = angular.element("span.ui-keyboard-text:contains(' OK')")

            buttonContent.attr('class', 'xrx-button-text')
        }
        scope.onVisible()
    }
    change(scope, elem) {
        scope.ngModel = elem.first().getkeyboard().$preview.val()
        scope.$apply()
        scope.onChange()
    }
    static directiveFactory(appSettings) {
        xwKeyboard.instance = new xwKeyboard(appSettings)
        return xwKeyboard.instance
    }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwKeyboard.directive.js